"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VTabsPanel = void 0;
var react_1 = __importStar(require("react"));
var TabPanel_1 = require("./TabPanel/TabPanel");
var style_1 = require("./style");
var core_1 = require("@blueprintjs/core");
var VCarouselMultiple_1 = __importDefault(require("../Scroll/CarouselMultiple/VCarouselMultiple"));
var Item_1 = __importDefault(require("../Scroll/CarouselMultiple/components/Item"));
var lodash_1 = require("lodash");
var Alert = core_1.Alert;
var VTabsPanel = function (props) {
    var getContent = function (key) {
        if (key === void 0) { key = props.tabList[0].key; }
        if (!key) {
            return null;
        }
        var content = props.tabList[0].content;
        props.tabList.forEach(function (tab) {
            if (tab.key === key) {
                content = tab.content;
            }
        });
        return content;
    };
    var getTab = function (key) {
        return (0, lodash_1.find)(props.tabList, { key: key });
    };
    var getFindNextVisible = function () {
        return (0, lodash_1.find)(props.tabList, { hidden: false });
    };
    var getActiveTab = function (active) {
        if (active) {
            var tab = getTab(active);
            if (tab && !tab.hidden) {
                return tab.key;
            }
        }
        var next = getFindNextVisible();
        return next ? next.key : '';
    };
    var _a = (0, react_1.useState)({
        active: getActiveTab("".concat(props.active)),
        content: getContent(getActiveTab("".concat(props.active))),
        possibleKey: ''
    }), state = _a[0], setState = _a[1];
    var _b = (0, react_1.useState)(false), isOpenConfirmationDialog = _b[0], setIsOpenConfirmationDialog = _b[1];
    (0, react_1.useEffect)(function () {
        var act = getActiveTab("".concat(state.active));
        setState({
            active: act,
            content: getContent(act),
            possibleKey: ''
        });
    }, [props.tabList]);
    (0, react_1.useEffect)(function () {
        var act = getActiveTab("".concat(props.active));
        setState({
            active: act,
            content: getContent(act),
            possibleKey: ''
        });
    }, [props.active]);
    var toggleIsOpenDialogOpen = function () {
        setIsOpenConfirmationDialog(!isOpenConfirmationDialog);
    };
    var handleChangeTab = function (key) {
        if (props.beforeChangeTabValidation && state.active !== key) {
            toggleIsOpenDialogOpen();
            setState(__assign(__assign({}, state), { possibleKey: key }));
        }
        else {
            changeTab(key);
        }
    };
    var changeTab = function (key) {
        props.tabList.forEach(function (item) {
            if (item.key === key) {
                props.handleChange(item);
                setState(__assign(__assign({}, state), { active: key, content: item.content }));
            }
        });
    };
    var handleOkConfirmation = function () {
        changeTab(state.possibleKey);
        toggleIsOpenDialogOpen();
    };
    var tabsAlertProps = props.tabsAlertProps, isResponsive = props.isResponsive, options = __rest(props, ["tabsAlertProps", "isResponsive"]);
    var active = state.active, content = state.content;
    return (react_1.default.createElement(style_1.ContainerTabsPanel, null,
        react_1.default.createElement(style_1.ContainerTabs, { borderBottom: options.borderBottom, activeColor: options.activeColor, lineColor: options.lineColor },
            react_1.default.createElement(VCarouselMultiple_1.default, { padding: props.tabsTagsContainerPadding, isResponsive: isResponsive }, options.tabList
                .filter(function (tab) { return !tab.hidden; })
                .map(function (tab) { return (react_1.default.createElement(Item_1.default, { className: "item", key: tab.key },
                react_1.default.createElement(TabPanel_1.VTabPanel, { backgroundColor: options.backgroundColor, activeBackgroundColor: options.activeBackgroundColor, key: tab.key, id: tab.key, handleOnClick: handleChangeTab, label: tab.label, active: active === tab.key, icon: tab.icon, textColor: options.textColor, borderColor: options.borderColor, activeColor: options.activeColor, activeTextColor: options.activeTextColor, textColorBadge: tab.textColorBadge, backgroundColorBadge: tab.backgroundColorBadge, dataBadge: tab.dataBadge, size: options.size, activeBorderColor: options.activeBorderColor, padding: options.tabsTagItemPadding }))); })),
            react_1.default.createElement(style_1.TabsSpaceFiller, null)),
        !props.mountAllTabs && (react_1.default.createElement(style_1.ContainerContent, { backgroundColor: options.backgroundColor, padding: options.padding, borderColor: options.borderColor, elevation: options.elevation }, content)),
        props.mountAllTabs && (react_1.default.createElement(style_1.ContainerContent, { backgroundColor: options.backgroundColor, padding: options.padding, borderColor: options.borderColor, elevation: options.elevation }, props.tabList.map(function (tab) { return (react_1.default.createElement("div", { style: getStyle(tab.key === state.active) }, tab.content)); }))),
        react_1.default.createElement(Alert, { canEscapeKeyCancel: (tabsAlertProps && tabsAlertProps.canEscapeKeyCancel) || false, canOutsideClickCancel: tabsAlertProps && tabsAlertProps.canOutsideClickCancel && true, cancelButtonText: (tabsAlertProps && tabsAlertProps.cancelButtonText) || 'Cancel', confirmButtonText: (tabsAlertProps && tabsAlertProps.confirmButtonText) || 'Ok', intent: (tabsAlertProps && tabsAlertProps.intent) || 'warning', icon: (tabsAlertProps && tabsAlertProps.icon) || 'warning-sign', style: (tabsAlertProps && tabsAlertProps.style) || {}, className: (tabsAlertProps && tabsAlertProps.className) || '', isOpen: isOpenConfirmationDialog, onCancel: toggleIsOpenDialogOpen, onConfirm: handleOkConfirmation },
            react_1.default.createElement("p", null, (tabsAlertProps && tabsAlertProps.bodyText) ||
                "Changes will be lost!"))));
};
exports.VTabsPanel = VTabsPanel;
var getStyle = function (active) {
    return active
        ? {
            width: "100%",
            height: "100%",
            visibility: "visible",
            display: 'block'
        }
        : {
            width: "0%",
            height: "0%",
            visibility: "hidden",
            position: 'absolute',
            left: '-1000000',
            top: '-1000000',
            display: 'none'
        };
};
